/* eslint-disable consistent-return */
/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { Col, Button, message } from 'antd';
import { CloseCircleOutlined } from '@ant-design/icons';
import axios from 'axios';

const capitalizeFirstLetter = ([first, ...rest]) => [first.toUpperCase(), ...rest].join('');

// Cuando Django corre con DEBUG=True, un 500 responde con la página técnica de
// error (HTML) en vez de JSON. El mensaje real de la excepción sí viaja ahí,
// dentro de <pre class="exception_value">, pero escapado como HTML.
const extractDjangoExceptionMessage = (html) => {
  if (typeof html !== 'string') return null;
  const match = /<pre class="exception_value">([\s\S]*?)<\/pre>/.exec(html);
  if (!match) return null;
  const [, exceptionHtml] = match;
  const div = document.createElement('div');
  div.innerHTML = exceptionHtml;
  const text = (div.textContent || div.innerText || '').trim();
  return text || null;
};

export const onError = (err, setLoading = null, formsInstances = [], setCurrentTabKey) => {
  // eslint-disable-next-line no-console
  if (!axios.isCancel(err)) {
    if (typeof setLoading === 'function') {
      setLoading(false);
    }
    if (err?.response?.data?.detail) {
      const { detail } = err.response.data;
      const contenido = Array.isArray(detail) ? `${detail.join(', ').replace('.', '')}.` : detail;
      return message.warn({
        content: (
          <Col>
            <p style={{ margin: 0, display: 'block', textAlign: 'center' }}>
              {contenido}
            </p>
            <Button
              icon={<CloseCircleOutlined />}
              onClick={() => message.destroy()}
              type="link"
              style={{
                position: 'absolute',
                top: -30,
                right: -20,
              }}
            />
          </Col>
        ),
        duration: 4.5,
      });
    }
    if (err?.response?.data
        && err?.response?.headers['content-type'].includes('application/json')) {
      const keys = Object.keys(err.response.data);
      let normalized = keys.map((key) => {
        let errors = '';
        const value = err.response.data[key];
        if (Array.isArray(value)) {
          // Cada elemento puede ser un string o un objeto de error (ej. {id, error})
          errors = `${value.map((item) => {
            if (item && typeof item === 'object') {
              return item.error || item.detail || item.message || JSON.stringify(item);
            }
            return item;
          }).join(', ').replace('.', '')}.`;
        } else if (value && typeof value === 'object') {
          errors = `${Object.values(value).flat().join(', ').replace('.', '')}.`;
        } else if (typeof value === 'string') {
          errors = value;
        }
        return ({
          prop: capitalizeFirstLetter(key.replace(/_/g, ' ')),
          errors,
        });
      });
      normalized = normalized.filter((i) => i.errors.length);
      if (normalized.length) {
        return message.warn({
          content: (
            <Col>
              <strong>Solucione las siguientes advertencias</strong>
              <br />
              {normalized.map((item) => (
                <React.Fragment key={item.prop}>
                  <p style={{ margin: 0, display: 'block', textAlign: 'center' }}>
                    {item.errors}
                  </p>
                </React.Fragment>
              ))}
              <Button
                icon={<CloseCircleOutlined />}
                onClick={() => message.destroy()}
                type="link"
                style={{
                  position: 'absolute',
                  top: -30,
                  right: -20,
                }}
              />
            </Col>
          ),
          duration: 30,
        });
      }
    } else if (!err?.errorFields) {
      if (!err?.response) {
        // Sin respuesta del servidor (red caida, backend reiniciando, etc.): no es un
        // error de datos/validacion sino una falla de conexion transitoria -- mensaje
        // mas amigable que el generico "Ha ocurrido un error".
        return message.warn('Restableciendo conexión, intenta de nuevo en unos segundos.');
      }
      const isLocalhost = err?.response?.config?.baseURL?.includes('localhost');
      if (isLocalhost) {
        const djangoException = extractDjangoExceptionMessage(err?.response?.data);
        if (djangoException) {
          return message.warn(djangoException, 6);
        }
      }
      return message.warn(err?.message && isLocalhost
        ? err.message : 'Ha ocurrido un error');
    } else if (err.errorFields) {
      const forms = formsInstances.map(({ __INTERNAL__, getFieldsError }) => ({
        tabKey: __INTERNAL__?.name,
        keys: getFieldsError()?.filter((e) => e?.errors?.length)?.map((e) => e.name[0]),
      }));
      const errorKeys = err.errorFields.map((e) => e.name[0]);
      const formWithErrors = forms.find((f) => f.keys.some((k) => errorKeys.includes(k)));
      if (formWithErrors) {
        setTimeout(() => {
          if (typeof setCurrentTabKey === 'function') {
            setCurrentTabKey(formWithErrors.tabKey);
          }
        });
      }
    }
  }
};

export const onSuccess = (res = {}, msg = 'Acción/Operación realizada correctamente', duration = 2.5) => {
  message.destroy();
  if (res?.data) {
    return message.info(res.data.detail || msg, duration);
  }
  return message.info(msg, duration);
};

export const onAlert = (msg, duration = 2.5) => {
  message.destroy();
  return message.warn(msg, duration);
};
